import { Route, Switch, useLocation } from 'react-router-dom';
import PageContainer from '../components/AdminPageContainer';
import AdminSideNav from '../components/AdminSideNav';
import ProfileSideNav from '../components/ProfileSideNav';

// Main
import Dashboard from '../views/Main/Dashboard';
import Runs      from '../views/Main/Runs';
import Specs     from '../views/Main/Specs';
import Reports   from '../views/Main/Reports';

// Admin
import AdminUsers from '../views/Admin/Users';
// import AdminBilling from '../views/Admin/Billing';
import AdminProjects from '../views/Admin/Projects';
import AdminOrganizations from '../views/Admin/Organizations';
import RouteContainer from '../components/RouteContainer';

// Profile
import Info from '../views/Profile/Info';
import APIKeys from '../views/Profile/APIKeys';

// Payment
// import Payment from '../views/Payment';

function Routes({ needs_payment }) {
	const location = useLocation();

	// if(needs_payment && location.pathname !== `/payment`) {
	// 	return <Redirect to="/payment" />
	// }

	if(location.pathname === `/`) {
		//return <Redirect to="/runs" />
	}

	return (
		<Switch>
			<Route path="/admin/:path?" exact>
				<AdminSideNav />
				<PageContainer>
					<RouteContainer>
						<Switch>
							<Route path="/admin/users" exact component={AdminUsers} />
							{/* <Route path="/admin/billing" exact component={AdminBilling} /> */}
							<Route path="/admin/projects" exact component={AdminProjects} />
							<Route path="/admin/organizations" exact component={AdminOrganizations} />
						</Switch>
					</RouteContainer>
				</PageContainer>
			</Route>

			<Route path="/profile/:path?" exact>
				<ProfileSideNav />
				<PageContainer>
					<RouteContainer>
						<Switch>
							<Route path="/profile/info" exact component={Info} />
							<Route path="/profile/api-keys" exact component={APIKeys} />
						</Switch>
					</RouteContainer>
				</PageContainer>
			</Route>

			{/* <Route path="/payment" exact>
				<PageContainer>
					<Switch>
						<Route path="/payment" exact component={Payment} />
					</Switch>
				</PageContainer>
			</Route> */}

			<Route>
				{/* <TopNav /> */}
				<PageContainer>
					<RouteContainer>
						<Switch>
							<Route exact path="/">
								<Dashboard />
							</Route>
							<Route path="/runs">
								<Runs />
							</Route>
							<Route path="/specs">
								<Specs />
							</Route>
							<Route path="/suites">
								<Specs />
							</Route>
							<Route path="/reports">
								<Reports />
							</Route>
						</Switch>
					</RouteContainer>
				</PageContainer>
			</Route>
		</Switch>
	);
}

export default Routes;
